import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { BlogService, BlogArticle } from './blog.service';

@Injectable({
  providedIn: 'root'
})
export class BlogResolver implements Resolve<BlogArticle | null> {
  constructor(private blogService: BlogService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BlogArticle | null> {
    const slug = route.paramMap.get('slug');
    
    if (!slug) {
      return of(null);
    }

    return new Observable(observer => {
      this.blogService.getArticleBySlug(slug).subscribe({
        next: (article) => {
          observer.next(article || null);
          observer.complete();
        },
        error: (error) => {
          console.error('BlogResolver - error loading article:', error);
          observer.next(null);
          observer.complete();
        }
      });
    });
  }
}
